// src/ui/features/calculator/components/ProOverlay.jsx
import React from "react";
import { CrownIcon } from "../../primatives/Icons";

export default function ProOverlay({
  title = "Pro feature",
  text = "Upgrade to Pro to unlock these features:",
  onClick,

  bullets = ["Target insights", "Distribution analysis", "Export & import tools"],
  cta = "Upgrade to Pro",
  note = "Secure checkout. Login Required.",
}) {
  return (
    <div className="absolute inset-0 z-10 rounded-2xl">
      {/* Backdrop (theme aware) */}
      <div
        className="
          absolute inset-0 rounded-2xl
          bg-white/55 backdrop-blur-[8px]
          dark:bg-neutral-950/60
        "
      />

      {/* Subtle premium glow (works in both themes) */}
      <div
        className="
          absolute -inset-px rounded-2xl
          bg-gradient-to-b from-orange-500/20 via-transparent to-transparent
        "
      />

      {/* Soft ring (theme aware) */}
      <div className="absolute inset-0 rounded-2xl ring-1 ring-black/5 dark:ring-white/10" />

      {/* Content */}
      <div className="relative flex h-full items-center justify-center p-5">
        <div
          className="
            w-full max-w-[400px] overflow-hidden rounded-2xl
            border border-neutral-200 bg-white/90 shadow-2xl
            dark:border-neutral-800 dark:bg-neutral-950/80
          "
        >
          {/* Top accent */}
          <div className="h-1 w-full bg-gradient-to-r to-transparent" />

          <div className="p-5">
            {/* Badge + status */}
            <div className="flex items-start justify-between gap-3">
              <div
                className="
                  inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-xs font-semibold
                  bg-orange-500/10 text-orange-700 ring-1 ring-orange-500/20
                  dark:bg-orange-500/15 dark:text-orange-200 dark:ring-orange-500/25
                "
              >
                <CrownIcon className="h-4 w-4" />
                Pro
              </div>

              <div className="text-[11px] text-neutral-500 dark:text-neutral-400">
                Locked
              </div>
            </div>

            {/* Title */}
            <div className="mt-3 text-lg font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
              {title}
            </div>

            {/* Description */}
            <div className="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-300">
              {text}
            </div>

            {/* Benefits */}
            {bullets?.length ? (
              <div className="mt-4 grid gap-2">
                {bullets.slice(0, 4).map((b) => (
                  <div
                    key={b}
                    className="
                      flex items-center gap-2 rounded-lg px-3 py-2 text-sm
                      border border-neutral-200 bg-neutral-50 text-neutral-800
                      dark:border-neutral-800 dark:bg-white/5 dark:text-neutral-200
                    "
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-orange-500/90" />
                    <span className="font-medium">{b}</span>
                  </div>
                ))}
              </div>
            ) : null}

            {/* CTA */}
            <div className="mt-5">
              <button
                type="button"
                onClick={onClick}
                className="
                  inline-flex w-full items-center justify-center gap-2
                  rounded-xl bg-orange-500 px-4 py-2.5
                  text-sm font-semibold text-white
                  shadow-sm shadow-orange-500/20
                  transition hover:bg-orange-400
                  focus:outline-none focus:ring-2 focus:ring-orange-400/60
                "
              >
                {cta}
              </button>

              <div className="mt-2 text-center text-[11px] text-neutral-500 dark:text-neutral-400">
                {note}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
